import { render, staticRenderFns } from "./ContentEventFlyer.vue?vue&type=template&id=107ad1b7"
import script from "./ContentEventFlyer.vue?vue&type=script&lang=ts"
export * from "./ContentEventFlyer.vue?vue&type=script&lang=ts"
import style0 from "./ContentEventFlyer.vue?vue&type=style&index=0&id=107ad1b7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports